(function () {
    "use strict";

    Components.NylasRedirect = {
        controller: "NylasRedirectController",
        name: "hbNylasRedirect",
        templateUrl:
            "angular/app/modules/core/features/nylas_integration/nylas_redirect_page_template.html",
    };
})();
